/* eslint-disable react/display-name */
import React, { memo, useEffect } from 'react';
import { dataLayer } from '@weatherbug/common';
import { reduxConnect } from '../../common';
import PropTypes from 'prop-types';
import { translate } from '../../common/translation/translate';
import { WeatherDetailsListItem,
    WeatherDetailsCellContainerLeft,
    WeatherDetailsCellContainerRight,
    WeatherDetailsCellLabel,
    WeatherDetailsCellValue } from './weatherDetailsStyledComponents';
import { UvIndexDetails } from './uvIndexDetails';
import { parseAndFormatISO8601DateStr } from '../../common/utilities/dateTimeUtils';

const dateFormat = 'h:mm a';
const defaultObsValue = '--';

const fetchAlmanacData = async(authId, secret, baseUrl, latitude, longitude, getAlmanacByLatLon) => {
    try {
        if (baseUrl && authId && secret && latitude && longitude) {
            await getAlmanacByLatLon(latitude, longitude, baseUrl, authId, secret);
        }

    } catch (error) {
        console.log(error);
    }
};

const mapStoreStateToProps = storeState => {
    const { almanac } =  storeState;

    const appState = storeState.appState.appState || {};
    const { authId, secret, almanacBaseUrl, stdParameters } = appState;

    const locality = appState.locality || {};
    const latitude = locality.Latitude;
    const longitude = locality.Longitude;

    const almanacResult = almanac?.almanac;
    const almanacSolarData =almanacResult?.s?.length > 0 && almanacResult.s[0];
    const moonPhaseName = almanacResult?.l?.length > 0 ? almanacResult.l[0].pn : defaultObsValue;

    return {
        authId,
        secret,
        almanacBaseUrl,
        latitude,
        longitude,
        sunriseIsoString: almanacSolarData.srdtl,
        sunsetIsoString: almanacSolarData.ssdtl,
        moonPhaseName,
        stdParameters
    };
};

const mapDispatchToProps = {
    getAlmanacByLatLon: dataLayer.actions.getAlmanacByLatLon
};

export const AlmanacDetails = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo(({ 
    latitude, 
    longitude, 
    authId, 
    secret, 
    almanacBaseUrl, 
    sunriseIsoString, 
    sunsetIsoString, 
    moonPhaseName, 
    getAlmanacByLatLon }) => {

    useEffect(() => {
        fetchAlmanacData(authId, secret, almanacBaseUrl, latitude, longitude, getAlmanacByLatLon);
    }, [latitude, longitude, authId, secret, almanacBaseUrl, getAlmanacByLatLon]);

    const sunrise = sunriseIsoString ? parseAndFormatISO8601DateStr(sunriseIsoString, dateFormat, false) : defaultObsValue;
    const sunset = sunsetIsoString ? parseAndFormatISO8601DateStr(sunsetIsoString, dateFormat, false) : defaultObsValue;

    return (
        <>
            <WeatherDetailsListItem key='sunrise-moon'>
                <WeatherDetailsCellContainerLeft>
                    <WeatherDetailsCellLabel>{translate('sunrise')}</WeatherDetailsCellLabel>
                    <WeatherDetailsCellValue>{sunrise}</WeatherDetailsCellValue>
                </WeatherDetailsCellContainerLeft>
                <WeatherDetailsCellContainerRight>
                    <WeatherDetailsCellLabel>{translate('moon')}</WeatherDetailsCellLabel>
                    <WeatherDetailsCellValue>{moonPhaseName}</WeatherDetailsCellValue>
                </WeatherDetailsCellContainerRight>
            </WeatherDetailsListItem>
            <WeatherDetailsListItem key='sunset-uv'>
                <WeatherDetailsCellContainerLeft>
                    <WeatherDetailsCellLabel>{translate('sunset')}</WeatherDetailsCellLabel>
                    <WeatherDetailsCellValue>{sunset}</WeatherDetailsCellValue>
                </WeatherDetailsCellContainerLeft>
                <WeatherDetailsCellContainerRight>
                    <WeatherDetailsCellLabel>{translate('uvIndex')}</WeatherDetailsCellLabel>
                    <WeatherDetailsCellValue>
                        <UvIndexDetails />
                    </WeatherDetailsCellValue>
                </WeatherDetailsCellContainerRight>
            </WeatherDetailsListItem>
        </>
    );
}));

AlmanacDetails.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    authId: PropTypes.string,
    secret: PropTypes.string,
    stdParameters: PropTypes.object,
    getAlmanacByLatLon: PropTypes.func,
    sunrise: PropTypes.string,
    sunset: PropTypes.string,
    moonPhaseName: PropTypes.string
};

AlmanacDetails.displayName = 'AlmanacDetails';
